<template>
  <div
    :id="id"
    class="contact-footer-accordion__tab"
    :class="{ 'contact-footer-accordion__tab--open': isOpen }"
  >
    <button
      class="contact-footer-accordion__button"
      :aria-selected="isOpen"
      @click="$emit('clickTab', $event)"
      type="button"
      role="tab"
    >
      <span class="contact-footer-accordion__title">
        <h3>{{ title }}</h3>
      </span>
      <span class="plus-minus"></span>
    </button>
    <transition name="expand">
      <div
        v-show="isOpen"
        role="tabpanel"
        class="contact-footer-accordion__content"
      >
        <div class="contact-footer-accordion__content-inner">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class ContactFooterAccordionTab extends Vue {
  @Prop() id!: string;
  @Prop({ default: undefined }) title!: string;
  @Prop({ default: undefined }) icon!: string;
  @Prop({ default: false }) isOpen!: boolean;
}
</script>

<style lang="postcss" scoped>
.contact-footer-accordion__tab--open .contact-footer-accordion__button {
  & .plus-minus {
    &:after {
      @apply rotate-0 transform opacity-0;
    }
  }
}

.contact-footer-accordion__button {
  @apply flex items-center justify-center;
  @apply appearance-none bg-transparent outline-none;
  @apply mx-auto;
  @apply border-0;
  @apply w-full;
}

.contact-footer-accordion__title {
  & > h3 {
    @apply text-white;
    @apply p-4;
  }
}

.plus-minus {
  @apply relative;
  @apply h-3 w-3;
  @apply flex-shrink-0 flex-grow-0;

  &:before,
  &:after {
    content: '';
    top: 50%;
    @apply absolute left-0 right-0;
    @apply h-0;
    @apply border-b border-t border-white;
    @apply bg-white;
    @apply origin-center transition-all duration-200;
  }

  &:after {
    @apply rotate-90 transform opacity-100;
  }
}

.contact-footer-accordion__content {
  @apply px-3 py-5;
  @apply transition-all duration-200;
}

.expand-enter-active,
.expand-leave-to {
  @apply overflow-hidden opacity-0;
  @apply h-0;
}
</style>
